import { SapphireDb, SapphireDbOptions } from "sapphiredb";

export class Socket {
  static create(config: SapphireDbOptions): SapphireDb {
    return new SapphireDb(config);
  }
}
